import { getChooseCampaignTableInfo } from 'modules/experiments/ducks/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { PAGE_SIZES_MEDIUM, PaginationFooter, PaginationUpdateEvent } from 'ui/paginationFooter';
import {
  refetchCampaigns,
  setChooseCampaignPaginationInfo,
} from 'modules/experiments/ducks/actions';

export const ChooseCampaignPagination = () => {
  const dispatch = useDispatch();
  const { count, limit, page } = useSelector(getChooseCampaignTableInfo);

  const handlePaginationUpdate = (paginationInfo: PaginationUpdateEvent): void => {
    dispatch(setChooseCampaignPaginationInfo(paginationInfo));
    dispatch(refetchCampaigns());
  };

  return (
    <PaginationFooter
      data-test="choose-campaign-pagination"
      onUpdate={handlePaginationUpdate}
      pageSizes={PAGE_SIZES_MEDIUM}
      currentPage={page}
      itemsPerPage={limit}
      numItems={count}
    />
  );
};
